import { makeAutoObservable, runInAction } from 'mobx';

import { frontApi, API_ROUTES } from '_app/api';
// import toast from 'utils/toast';

export class RolesStore {
  constructor() {
    makeAutoObservable(this);
  }

  isLoading = false;

  games = [];

  gamesInfo = [];

  errors = {};

  gameInfo = {};

  roomPlayers = {
    data: [],
    isLoading: false,
    error: null,
  };

  playersModalRoomId = null;

  fetchGames = async () => {
    try {
      const { data } = await frontApi(API_ROUTES.games);

      runInAction(() => {
        this.games = data.filter(game => game.available);
      });
    } catch (error) {
      console.error(error);
    }
  };

  setGamesInfo = data => {
    this.gamesInfo = data;
  };

  setGameInfo = data => {
    this.gameInfo = data;
  };

  setPlayerModalRoomId = id => {
    this.playersModalRoomId = id;
  };

  fetchRoomPlayers = async (shortname, roomId) => {
    try {
      this.roomPlayers.isLoading = true;
      const { data } = await frontApi(
        API_ROUTES.allPlayersInRoom(shortname, roomId)
      );

      runInAction(() => {
        this.playersModalRoomId = roomId;
        this.roomPlayers.data = data;
      });
    } catch (error) {
      console.error(error);
      this.playersModalRoomId = null;
    } finally {
      this.roomPlayers.isLoading = false;
    }
  };

  kickPlayerFromRoom = async (shortname, roomId, socketId) => {
    try {
      await frontApi.post(API_ROUTES.kickPlayerFromRoom(shortname), {
        data: {
          socketId,
          roomId,
        },
        reason: 'KICKED_BY_ADMIN',
      });

      this.fetchRoomPlayers(shortname, roomId);
    } catch (error) {
      console.error(error);
    }
  };

  closeEmptyRoom = async (shortname, roomId) => {
    try {
      await frontApi.post(API_ROUTES.closeEmptyRoom(shortname), {
        roomId,
      });
    } catch (error) {
      console.error(error);
    }
  };
}

export default new RolesStore();
